import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param serviceSchema ServiceSchemaModel
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (serviceSchema, organisationId) {
    var url = applyPathVariables(EndPoints.SERVICE_SCHEMA, {
        organisationId: organisationId,
        schemaId: serviceSchema.id
    });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: serviceSchema });
    return request.execute();
});
